import { W as WuiStatus$1, d as defineCustomElement$1 } from './p-aqq22Qbe.js';

const WuiStatus = WuiStatus$1;
const defineCustomElement = defineCustomElement$1;

export { WuiStatus, defineCustomElement };
